// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assests/background-image/MagnumMetaDAO.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assests/background-image/ecosystemBgHome.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_main_container {
  /* background-repeat: no-repeat; */
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.magnumDao_bgi{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
}
.hrefReadMore{
  text-decoration: none;
}
.forge-grp-btn a{
  text-decoration: none;
}
.topleft {
  height: 8rem;
  width: 11rem;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  background: linear-gradient(327deg, rgb(232 68 39), rgb(35 75 153 / 0%));
  filter: blur(90px);
}

.topright {
  height: 28rem;
  width: 10rem;
  position: absolute;
  z-index: -1;
  top: -10px;
  right: 0;
  background: linear-gradient(164deg, rgb(232, 68, 39), rgb(35 75 153));
  filter: blur(130px);
}

.bottom-left {
  top: 180rem;
  height: 28rem;
  width: 7rem;
  position: absolute;
  z-index: -1;
  left: 0;
  background: linear-gradient(
    164deg,
    rgb(232 68 39 / 55%),
    rgb(35 75 153 / 45%)
  );
  filter: blur(160px);
}

.bottom-right {
  height: 28rem;
  width: 10rem;
  position: absolute;
  z-index: -1;
  top: 118rem;
  right: 0;
  background: linear-gradient(
    164deg,
    rgb(232 68 39 / 55%),
    rgb(35 75 153 / 45%)
  );
  filter: blur(130px);
}

.meta-forge {
  justify-content: space-between;
  align-items: center;
  margin-top: 7rem;
}

.mt-fg-img {
  display: flex;
  justify-content: center;
  width: 500px;
  align-items: center;
  flex-grow: 1;
}
.mt-fg-img img {
  width: 560px;
  height: 560px;
}

.mt-fg-cnt {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;
  width: 50%;
  flex-grow: 1;
}

.section-title {
  font-weight: 700;
  font-size: 50px;
}

.forge-text-para {
  font-size: 16px;
}

/* Magnum DAO section */

.magnum-left-box {
  width: 950px;
}

.magnum-dao-para {
  font-size: 22px;
  font-weight: 400;
  text-align: left;
}

.mgnum-img-cntr {
  width: 450px;
}

.mgnm-rm-btn {
  margin-left: 2.5rem;
  margin-top: 3rem;
}

.magnum-dao-img {
  width: 100%;
  height: 650px;
}

.eco-card-cnt {
  width: 40px;
  height: 40px;
  background-color: #337ab7;
  box-shadow: 2px 2px 5px 0px #00000029;
  font-size: 24px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

/* Magnum Csection */

.eco-card-size {
  width: 350px;
  padding: 0 20px;
  border-right: 1px dotted #7c7c7c;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-grow: 1;
}

.eco-card-main {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  /* align-items: center; */
}

.eco-h1-title {
  font-size: 28px;
  font-weight: 800;
  color: #000000;
}

.eco-card-para {
  font-size: 18px;
  color: #515151;
  font-weight: 400;
}

/* News section */

.news_card {
  width: 340px;
  height: auto;
  padding: 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;
  border-radius: 20px;
  box-shadow: 0px 4px 10px 0px #00000033;
}

.news_card:hover {
  scale: 1.05;
  cursor: pointer;
}

.newcard_images {
  width: 100%;
  border-radius: inherit;
}

.new_card_title {
  font-weight: 600;
  font-size: 20px;
}

.news_card_descr {
  font-weight: 400;
  font-size: 15px;
  color: #515151;
}

/* ommunity icon */
.community-img-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
}
.comm_icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #ffff, #fff, #fff) padding-box,
    linear-gradient(180deg, #ac8642 0%, #e5c06b 49.5%, #b18b46 100%) border-box;
  border-radius: 20px;
  border: 2px solid transparent;
  cursor: pointer;
}

.magnumdao-cards-contain {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
}

.magnumDao-crds {
  width: 410px;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  padding: 4px 16px;
  box-shadow: 0 0 10px 0 #00000033;
}

.manuDa-img {
  right: 0px;
  position: relative;
  top: -17px;
}

/* .manuDa-texts{
  padding: 0 0 0 6.25rem;
} */

.manuDa-texts {
  flex-grow: 1;
}

.mgnm-card-div img{
  width: 65px;
  height: 65px;
}

.hrefReadMore{
  text-decoration: none;
}

.manuDa-texts h2 {
  font-size: 22px;
  font-weight: 600;
  /* line-height: 40px; */
}

.card_indexNum {
  font-size: 70px;
  font-weight: 700;
  color: #337ab71a;
}

.mgnum_dao_card {
  width: 430px;
}
.mgnum-dao-content {
  width: 58%;
}

.eco-card-size > div:first-child>img{
  width: 60px;
}

@media screen and (max-width: 1200px) {
  .eco-card-size {
    border: none;
  }
  .mgnum-dao-content{
    width: 100%;
    flex-grow: 1;
  }
  .mgnm-rm-btn{
    margin: 0 auto;
  }
  .manuDa-texts h2 {
    width: 90%;
  }
}

@media screen and (max-width: 992px) {
  .meta-forge {
    margin-top: 2rem;
    padding: 0 0.5rem;
  }

  .magnumdao-cards-contain {
    margin-top: 2rem;
  }

  .magnumDao-crds {
    width: 90%;
  }

  .news_card {
    width: 70%;
    margin: 0 auto;
  }
  
}

@media screen and (max-width: 720px) {
  .mt-fg-cnt {
    width: 100%;
  }
  .magnum-dao-img {
    width: 100%;
  }

  .eco-card-size {
    width: 90%;
    padding: 1rem;
  }

  .eco-card-para {
    height: auto;
    font-size: 16px;
  }
  .mgnum-dao-content{
    width: 100%;
    flex-grow: 1;
  }
  .mgnum_dao_card{
    width: 100%;
  }
  .rpsnbtn{
    width: 205px !important;
    font-size: 16px;
  }
  .home_main_container{
    gap: 2rem;
  }
  .mgnm-rm-btn{
    width: 205px;
    font-size: 16px;
  }
}

@media screen and (max-width: 600px) {
  .section-title {
    font-size: 32px;
    color: #000000;
    /* text-align: center; */
  }

  .mt-fg-img {
    width: 100%;
  }

  .mt-fg-img img {
    width: 100%;
    height: 100%;
  }

  .news_group_cards {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .news_card {
    width: 90%;
  }

  .eco-card-size {
    border: none;
  }
  .eco-card-size > div:first-child > div:first-child > img{
    width: 56px;
    height: 56px;
  }

  .magnum-dao-img {
    margin-top: 2rem;
  }
  .magnum-dao-para{
    font-size: 16px;
  }
  .ecobgcls{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: cover;
  }
}

@media screen and (max-width: 475px) {
  .card_indexNum {
    font-size: 50px;
  }
  .mgnum_dao_card{
    width: 95%;
  }
  .manuDa-texts h2 {
    line-height: normal;
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yDAAyE;EACzE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,wEAAwE;EACxE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP;;;;GAIC;EACD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,QAAQ;EACR;;;;GAIC;EACD,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;;AAEvB;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;+EAC6E;EAC7E,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;AAEF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,yDAA2E;IAC3E,4BAA4B;IAC5B,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":[".home_main_container {\n  /* background-repeat: no-repeat; */\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n}\n\n.magnumDao_bgi{\n  background-image: url('../../assests/background-image/MagnumMetaDAO.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.hrefReadMore{\n  text-decoration: none;\n}\n.forge-grp-btn a{\n  text-decoration: none;\n}\n.topleft {\n  height: 8rem;\n  width: 11rem;\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  background: linear-gradient(327deg, rgb(232 68 39), rgb(35 75 153 / 0%));\n  filter: blur(90px);\n}\n\n.topright {\n  height: 28rem;\n  width: 10rem;\n  position: absolute;\n  z-index: -1;\n  top: -10px;\n  right: 0;\n  background: linear-gradient(164deg, rgb(232, 68, 39), rgb(35 75 153));\n  filter: blur(130px);\n}\n\n.bottom-left {\n  top: 180rem;\n  height: 28rem;\n  width: 7rem;\n  position: absolute;\n  z-index: -1;\n  left: 0;\n  background: linear-gradient(\n    164deg,\n    rgb(232 68 39 / 55%),\n    rgb(35 75 153 / 45%)\n  );\n  filter: blur(160px);\n}\n\n.bottom-right {\n  height: 28rem;\n  width: 10rem;\n  position: absolute;\n  z-index: -1;\n  top: 118rem;\n  right: 0;\n  background: linear-gradient(\n    164deg,\n    rgb(232 68 39 / 55%),\n    rgb(35 75 153 / 45%)\n  );\n  filter: blur(130px);\n}\n\n.meta-forge {\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 7rem;\n}\n\n.mt-fg-img {\n  display: flex;\n  justify-content: center;\n  width: 500px;\n  align-items: center;\n  flex-grow: 1;\n}\n.mt-fg-img img {\n  width: 560px;\n  height: 560px;\n}\n\n.mt-fg-cnt {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 1rem;\n  width: 50%;\n  flex-grow: 1;\n}\n\n.section-title {\n  font-weight: 700;\n  font-size: 50px;\n}\n\n.forge-text-para {\n  font-size: 16px;\n}\n\n/* Magnum DAO section */\n\n.magnum-left-box {\n  width: 950px;\n}\n\n.magnum-dao-para {\n  font-size: 22px;\n  font-weight: 400;\n  text-align: left;\n}\n\n.mgnum-img-cntr {\n  width: 450px;\n}\n\n.mgnm-rm-btn {\n  margin-left: 2.5rem;\n  margin-top: 3rem;\n}\n\n.magnum-dao-img {\n  width: 100%;\n  height: 650px;\n}\n\n.eco-card-cnt {\n  width: 40px;\n  height: 40px;\n  background-color: #337ab7;\n  box-shadow: 2px 2px 5px 0px #00000029;\n  font-size: 24px;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n/* Magnum Csection */\n\n.eco-card-size {\n  width: 350px;\n  padding: 0 20px;\n  border-right: 1px dotted #7c7c7c;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  flex-grow: 1;\n}\n\n.eco-card-main {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  /* align-items: center; */\n}\n\n.eco-h1-title {\n  font-size: 28px;\n  font-weight: 800;\n  color: #000000;\n}\n\n.eco-card-para {\n  font-size: 18px;\n  color: #515151;\n  font-weight: 400;\n}\n\n/* News section */\n\n.news_card {\n  width: 340px;\n  height: auto;\n  padding: 1.5rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 1rem;\n  border-radius: 20px;\n  box-shadow: 0px 4px 10px 0px #00000033;\n}\n\n.news_card:hover {\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.newcard_images {\n  width: 100%;\n  border-radius: inherit;\n}\n\n.new_card_title {\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.news_card_descr {\n  font-weight: 400;\n  font-size: 15px;\n  color: #515151;\n}\n\n/* ommunity icon */\n.community-img-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4rem;\n}\n.comm_icon {\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(180deg, #ffff, #fff, #fff) padding-box,\n    linear-gradient(180deg, #ac8642 0%, #e5c06b 49.5%, #b18b46 100%) border-box;\n  border-radius: 20px;\n  border: 2px solid transparent;\n  cursor: pointer;\n}\n\n.magnumdao-cards-contain {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 25px;\n}\n\n.magnumDao-crds {\n  width: 410px;\n  height: fit-content;\n  display: flex;\n  align-items: center;\n  padding: 4px 16px;\n  box-shadow: 0 0 10px 0 #00000033;\n}\n\n.manuDa-img {\n  right: 0px;\n  position: relative;\n  top: -17px;\n}\n\n/* .manuDa-texts{\n  padding: 0 0 0 6.25rem;\n} */\n\n.manuDa-texts {\n  flex-grow: 1;\n}\n\n.mgnm-card-div img{\n  width: 65px;\n  height: 65px;\n}\n\n.hrefReadMore{\n  text-decoration: none;\n}\n\n.manuDa-texts h2 {\n  font-size: 22px;\n  font-weight: 600;\n  /* line-height: 40px; */\n}\n\n.card_indexNum {\n  font-size: 70px;\n  font-weight: 700;\n  color: #337ab71a;\n}\n\n.mgnum_dao_card {\n  width: 430px;\n}\n.mgnum-dao-content {\n  width: 58%;\n}\n\n.eco-card-size > div:first-child>img{\n  width: 60px;\n}\n\n@media screen and (max-width: 1200px) {\n  .eco-card-size {\n    border: none;\n  }\n  .mgnum-dao-content{\n    width: 100%;\n    flex-grow: 1;\n  }\n  .mgnm-rm-btn{\n    margin: 0 auto;\n  }\n  .manuDa-texts h2 {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 992px) {\n  .meta-forge {\n    margin-top: 2rem;\n    padding: 0 0.5rem;\n  }\n\n  .magnumdao-cards-contain {\n    margin-top: 2rem;\n  }\n\n  .magnumDao-crds {\n    width: 90%;\n  }\n\n  .news_card {\n    width: 70%;\n    margin: 0 auto;\n  }\n  \n}\n\n@media screen and (max-width: 720px) {\n  .mt-fg-cnt {\n    width: 100%;\n  }\n  .magnum-dao-img {\n    width: 100%;\n  }\n\n  .eco-card-size {\n    width: 90%;\n    padding: 1rem;\n  }\n\n  .eco-card-para {\n    height: auto;\n    font-size: 16px;\n  }\n  .mgnum-dao-content{\n    width: 100%;\n    flex-grow: 1;\n  }\n  .mgnum_dao_card{\n    width: 100%;\n  }\n  .rpsnbtn{\n    width: 205px !important;\n    font-size: 16px;\n  }\n  .home_main_container{\n    gap: 2rem;\n  }\n  .mgnm-rm-btn{\n    width: 205px;\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .section-title {\n    font-size: 32px;\n    color: #000000;\n    /* text-align: center; */\n  }\n\n  .mt-fg-img {\n    width: 100%;\n  }\n\n  .mt-fg-img img {\n    width: 100%;\n    height: 100%;\n  }\n\n  .news_group_cards {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .news_card {\n    width: 90%;\n  }\n\n  .eco-card-size {\n    border: none;\n  }\n  .eco-card-size > div:first-child > div:first-child > img{\n    width: 56px;\n    height: 56px;\n  }\n\n  .magnum-dao-img {\n    margin-top: 2rem;\n  }\n  .magnum-dao-para{\n    font-size: 16px;\n  }\n  .ecobgcls{\n    background-image: url('../../assests/background-image/ecosystemBgHome.png');\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n}\n\n@media screen and (max-width: 475px) {\n  .card_indexNum {\n    font-size: 50px;\n  }\n  .mgnum_dao_card{\n    width: 95%;\n  }\n  .manuDa-texts h2 {\n    line-height: normal;\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
